<template>
    <!-- Main content -->
    <div class="rbt-main-content">
        <div class="rbt-daynamic-page-content">

            <!-- Dashboard Center Content -->
            <div class="rbt-dashboard-content">
                <div class="content-page">
                    <template v-if="idResearch == 0">
                        <template v-if="flRealizaResearch">
                            <template v-if="!(utilizacoes && utilizacoes.permiteRealizarResearch) && flVerificouUtilizacoes">
                                <!-- nao pode realizar novo -->
                                <div class="chat-box-list pt--30">
                                    <div class="chat-box ai-speech bg-flashlight box-anime">
                                        <div class="inner top-flashlight leftside light-xl">
                                            <div class="chat-section">
                                                <div class="author">
                                                    <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                                </div>
                                                <div class="chat-content">
                                                    <h6 class="title">
                                                        SollAI
                                                    </h6>
                                                    <p class="mb--20">
                                                        Desculpe, parece que você atingiu seu limite de Researchs do contrato.
                                                        Entre em contato com um dos nossos consultores.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- ETAPA 0  -->
                            <div class="chat-box-list pt--30">
                                <div class="chat-box ai-speech bg-flashlight box-anime">
                                    <div class="inner top-flashlight leftside light-xl">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                            </div>
                                            <div class="chat-content">
                                                <h6 class="title">
                                                    SollAI
                                                </h6>
                                                <p class="mb--20"><span id="negrito">O que deseja fazer hoje?</span> Selecione uma função na qual eu possa atuar para você.</p>

                                                <div v-for="(item,index) in lstTipoResearch" :key="index">
                                                    <input type="radio" :id="'tipoResearch'+index" :name="'tipoResearch'+index" :value="item.idTipoResearch" v-model="idTipoResearch" />
                                                    <!--<label for="tipoResearch">Resumo de documentos e apontamento de informações importantes (PDF ou arquivos em Word)</label>-->
                                                    <label :for="'tipoResearch'+index" :data-bs-toggle="(item.dsTipoResearch != null?'popoverModelo':'')" data-bs-placement="top" title="Detalhes" :data-bs-content="getDataBs(item)">{{item.dsNome}}</label>
                                                </div>

                                                <div class="reaction-section">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup">
                                                        </div>
                                                        <div class="right-side-btn">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="proximo(0)">
                                                                <span class="ms-0">Próximo</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <!-- ARQUIVOS -->
                            <!-- ETAPA 1  -->
                            <div class="chat-box ai-speech bg-flashlight box-anime" v-if="etapa > 0" ref="etapa1">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>

                                            <p class="mb--20">Qual documento você deseja que eu trabalhe para você hoje?</p>
                                            <p>Selecione um arquivo em <span id="negrito">word</span> ou <span id="negrito">pdf</span>.</p>

                                            <label for="myfile" class="custom-file-upload ">Selecionar Arquivos</label>
                                            <input type="file" id="myfile" name="myfile" accept=".pdf,.doc,.docx" multiple @change="onFileChange">

                                            <div class="box-files mt-3" v-if="files">
                                                <div class="item-files me-2" v-for="(file, index) in files" :key="index">
                                                    <span class="me-3">{{file.name}}</span>
                                                    <button class="react-btn btn-default btn-small btn-border btn-selecionar px-2" @click="removeFile(index)" type="button"><i data-v-61dd7a3d="" class="feather-x"></i></button>
                                                </div>

                                            </div>

                                            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot=true v-if="false">
                                                <div class="dropzone-custom-content">
                                                    <h3 class="dropzone-custom-title">Arraste e solte para enviar conteúdo!</h3>
                                                    <div class="subtitle">...ou clique para selecionar um arquivo do seu computador</div>
                                                </div>
                                            </vue-dropzone>

                                            <div class="reaction-section">
                                                <div class="btn-grp">
                                                    <div class="left-side-btn dropup">
                                                        <ul class="dropdown-menu">

                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Renomear</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar PDF</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar Word</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar PDF</a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#"><i class="feather-file-text"></i> Baixar Word</a>
                                                            </li>
                                                            <!-- <li><a class="dropdown-item delete-item" href="#"><i class="feather-trash-2"></i> Deletar
                                        Chat</a>
                                    </li> -->
                                                        </ul>
                                                    </div>
                                                    <div class="right-side-btn">
                                                        <button class="react-btn btn-default btn-small btn-border  btn-selecionar" @click="proximo(1)">
                                                            <span class="ms-0">Próximo</span>
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="chat-box ai-speech bg-flashlight box-anime" v-if="etapa > 1" ref="etapa2">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>

                                            <p class="mb--20">Deseja fornecer mais algum detalhe? (não obrigatório)</p>
                                            <div class="form-group">
                                                <textarea id="pergunta" placeholder="Digite sua instrução" maxlength="1000" v-model="dsPrompt"></textarea>
                                            </div>


                                            <div class="reaction-section mt-3" v-if="utilizacoes && utilizacoes.permiteRealizarResearch">
                                                <div class="btn-grp">
                                                    <div class="left-side-btn dropup">

                                                    </div>
                                                    <div class="right-side-btn">
                                                        <button class="react-btn btn-default btn-small btn-border  btn-selecionar" @click="proximo(2)">
                                                            <span class="ms-0">Enviar</span>
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>
                        <template v-else-if="flVerificouRealizar">
                            <div class="chat-box-list pt--30">
                                <div class="chat-box chat-box-you author-speech bg-flashlight">
                                    <div class="inner">
                                        <div class="chat-section">
                                            <div class="author">
                                                <img class="w-100" src="assets/images/sollai/team-01.jpg" alt="Author">
                                            </div>
                                            <div class="chat-content">
                                                Aguarde a conclusão do research atual antes de realizar um novo.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <!--detalhes do research-->
                        <div class="chat-box-list pt--30" v-if="research">
                            <div class="chat-box ai-speech bg-flashlight box-anime pt--30">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>
                                            <p class="mb--0" v-if="research.dsNome">
                                                <strong>{{research.dsNome}}</strong>
                                            </p>
                                            <p class="mb--0" v-if="research.nmTipoResearch">
                                                <strong>Tipo: </strong> {{research.nmTipoResearch}}
                                            </p>
                                            <p class="mb--0" v-if="research.lstFonteDados">
                                                <strong>Fonte de dados: </strong>
                                                <a class="c-pointer item-fonte ms-2" href="javascript:void(0)" @click="download(item.urlArquivo)" :key="index" v-for="(item,index) in research.lstFonteDados">{{getNomeArquivo(item.urlArquivo)}}</a>
                                            </p>
                                            <p class="mb--0">
                                                <strong>Data da solicitação: </strong>{{research.dtInclusao}}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="chat-box ai-speech bg-flashlight box-anime pt--30">
                            <div class="inner top-flashlight leftside light-xl">
                                <div class="chat-section">
                                    <div class="author">
                                        <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                    </div>
                                    <div class="chat-content">
                                        <h6 class="title">
                                            SollAI
                                        </h6>
                                        <template v-if="statusResearch == 'Processando' || statusResearch == 'Iniciada'">
                                            <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                {{mensagemProcessando}}
                                            </p>
                                            <p class="txt-p txt-grey-3 txt-size-14 txt-w-5 mb-2">
                                                Por favor, aguarde um momento enquanto eu processo sua solicitação. Obrigado pela sua paciência e compreensão.
                                            </p>
                                            <div class="progress px-0 d-none">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: '20%'}"></div>
                                            </div>

                                        </template>
                                        <template v-if="statusResearch == 'Cancelada'">
                                            <span class="txt-erro txt-size-40">
                                                <i class="fas fa-exclamation-triangle txt-erro"></i>
                                            </span>
                                            <p class="txt-p txt-blue-1 txt-size-20 txt-w-bold mb-2">
                                                Erro ao processar a solicitação
                                            </p>
                                            <p class="txt-p txt-blue-1 txt-size-16 txt-w-5 mb-2">
                                                {{msgErro}}
                                            </p>
                                        </template>
                                        <template v-if="statusResearch == 'Finalizada'">
                                            <template vif="artefato">
                                                <p class="mb--20">Seu documento esta pronto!</p>
                                                <p>Faça o download do arquivo.</p>

                                                <div class="reaction-section">
                                                    <div class="btn-grp">
                                                        <div class="left-side-btn dropup">
                                                            <button data-bs-toggle="modal" data-bs-target="#shareModal"
                                                                    class="react-btn btn-default btn-small btn-border">
                                                                <i class="feather-share"></i>
                                                            </button>
                                                            <button type="button" class="react-btn btn-default btn-small btn-border dropdown-toggle d-none"
                                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i class="feather-more-vertical"></i>
                                                            </button>
                                                            <ul class="dropdown-menu">
                                                                <li>
                                                                    <a class="dropdown-item" href="#">
                                                                        <i class="feather-file-text"></i>
                                                                        Baixar PDF
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a class="dropdown-item" href="#">
                                                                        <i class="feather-file-text"></i>
                                                                        Baixar World
                                                                    </a>
                                                                </li>
                                                                <li><a class="dropdown-item" href="#"><i class="feather-file-text"></i>Imprimir</a></li>

                                                            </ul>
                                                        </div>
                                                        <div class="right-side-btn" v-if="research.resposta">
                                                            <button class="react-btn btn-default btn-small btn-border btn-selecionar" @click="downloadResearch(research.resposta.urlArquivo,research.dsNome)" v-if="research.resposta.urlArquivo">
                                                                <span class="ms-0">Fazer Download</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>


                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="statusResearch == 'Finalizada' && research">
                            <div class="chat-box ai-speech bg-flashlight box-anime pt--30" v-if="research.dsResposta">
                                <div class="inner top-flashlight leftside light-xl">
                                    <div class="chat-section">
                                        <div class="author">
                                            <img class="w-100" src="assets/images/sollai/avatar.png" alt="ChatenAI">
                                        </div>
                                        <div class="chat-content">
                                            <h6 class="title">
                                                SollAI
                                            </h6>
                                            <template>

                                                <p v-if="research.dsResposta" class="mb--20 resposta" style="white-space: pre-line;">
                                                    {{research.dsResposta}}
                                                </p>


                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </template>
                        <br>
                        <div class="d-flex justify-content-center ">
                            <button class="react-btn btn-default btn-small btn-border" @click="novo">
                                <span>Novo Research</span>
                            </button>
                        </div>
                    </template>
                </div>


                <HistoricoResearchs :seleciona="selecionaResearch" :reload="reloadHistorico" :idResearch="idResearch"></HistoricoResearchs>

            </div>
        </div>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import ModalDetalhes from '@/components/ModalDetalhes'

    import HistoricoResearchs from '@/components/HistoricoResearchs'

    export default {
        name: 'Research',
        components: { HistoricoResearchs, vueDropzone: vue2Dropzone, ModalDetalhes },
        props: {
            reload: Boolean,
            reloadNavegacao: Function,
        },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
        },
        data: function () {
            return {
                idResearch: 0,
                lstTipoResearch: [],
                idTipoResearch: 0,
                dsPrompt: null,

                arquivo: null,
                etapa: 0,
                msgErro: null,
                flReprocessar: false,
                statusResearch: null,
                research: null,
                reloadHistorico: false,

                dropzoneOptions: {
                    url: urlApi + '/Documento/EnviarDocumento',
                    maxFilesize: 0.5,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    autoProcessQueue: false,
                    headers: { "My-Awesome-Header": "header value" }
                },

                flRealizaResearch: false,
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                mensagemProcessando: "Processando solicitação...",
                flVerificouRealizar: false,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                files: [],
            }
        },
        methods: {
            selecionaResearch(idResearch) {
                this.idResearch = idResearch;
                this.load();
            },

            novo() {
                this.idResearch = 0;
                this.etapa = 0;
                this.idTipoResearch = null;
                this.arquivo = null;
                this.files = [];
                this.dsPrompt = null;


                this.load();
            },

            load() {
                if (this.idResearch != 0) {
                    this.carregaResearch();
                }

                this.carregaTipoResearch();
                this.verificaRealizaResearch();
                this.carregaUtilizacoes();
            },

            carregaTipoResearch() {
                let $this = this;
                $this.lstModelos = [];
                axios.get(`${urlApi}/Research/GetTipoResearch`, { showLoading: false, params: { } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTipoResearch = res.data.data;
                            setTimeout(function () {
                                $this.$nextTick(() => {
                                    $this.montaPopover();
                                });
                            },300);
                           
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    $this.hubConection.on("RecebeNotificacaoResearch", function (idResearch, status, dtAtualizacao) {
                        if ($this.idResearch == idResearch) {
                            $this.load();
                        } else {
                            avisoToast('Status do research atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                    });

                    $this.hubConection.on("AtualizaRealizarResearch", function (flRealizaResearch) {
                        $this.flRealizaResearch = flRealizaResearch == "Sim" || flRealizaResearch == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusResearch", function (idResearch, status,) {
                        if ($this.idResearch == idResearch) {
                            $this.mensagemProcessando = status;
                        }                       
                    });

                }
                catch (ex) {
                    console.log(ex);
                }
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.idTipoResearch) {
                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                            
                        } else {
                            avisoToast("Selecione um tipo de research", "warning");
                        }

                        break;

                    case 1:                        
                        if (this.files != null && this.files.length > 0) {
                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione um arquivo", "warning");
                        }

                        break;
                    case 2:
                        if (this.utilizacoes && this.utilizacoes.permiteRealizarResearch) {
                            this.enviarResearch();
                        } else {
                            avisoToast("Desculpe, parece que você atingiu seu limite de Researchs do contrato. Entre em contato com um dos nossos consultores.", "warning");
                        }
                        
                        break;
                    default:                        
                        break;
                }
            },

            enviarResearch() {
                let $this = this;
                $this.statusResearch = 'Processando';
                $this.disabled = true;

                const formData = new FormData();

                //const inputFile = document.querySelector("#myfile");
                //if (inputFile != null) {
                //    for (let i = 0; i < inputFile.files.length; i++) {
                //        formData.append("files", inputFile.files[i]);
                //    }
                //}
                for (let i = 0; i < this.files.length; i++) {
                    formData.append("files", this.files[i]);
                }

                formData.append("idTipoResearch", $this.idTipoResearch);
                if ($this.dsPrompt != null && $this.dsPrompt != "") {
                    formData.append("dsPrompt", $this.dsPrompt);
                }
                
                axios.post(`${urlApi}/Research/post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Research registrado com sucesso, acompanhe a situação no campo status da listagem.");
                            $this.reloadHistorico = !$this.reloadHistorico;
                            $this.reloadNavegacao();
                            $this.selecionaResearch(parseInt(res.data.data));
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar o research.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusResearch = 'Cancelada';
                        $this.msgErro = 'Não foi possível enviar o research.';
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o research.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Research/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de reseachs.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de reseachs.");
                        }
                        $this.loading.hide();
                    });
            },

            verificaRealizaResearch() {
                let $this = this;
                axios.get(`${urlApi}/Research/VerificaRealizarResearch`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaResearch = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            carregaResearch() {
                let $this = this;
                axios.get(`${urlApi}/Research/Get/${$this.idResearch}`)
                    .then(res => {
                        $this.research = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstResearchMovimento.length > 0) {
                                status = result.lstResearchMovimento[result.lstResearchMovimento.length - 1].dsMovimento;
                                $this.statusResearch = status;
                            }

                            var lstFonteDados, resposta = null;
                            if (result.lstResearchDocumento.length > 0) {
                                lstFonteDados = result.lstResearchDocumento.filter(x => x.flResposta == false);
                                resposta = (result.lstResearchDocumento.filter(x => x.flResposta == true) ? result.lstResearchDocumento.filter(x => x.flResposta == true)[0] : null);

                            }

                            $this.research = {
                                idResearch: result.research.idResearch,
                                dsLogin: result.research.dsLogin,
                                dsNome: result.research.dsNome,
                                dtInclusao: moment(result.research.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                nmTipoResearch: result.tipoResearch.dsNome,
                                status: status,
                                tipoResearch: result.tipoResearch,
                                lstFonteDados: lstFonteDados,
                                resposta: resposta,
                            };

                        } else {
                            avisoErro("Não foi possível carregar o artefato.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        //$this.loading.hide();
                    });
            },
                        
            download(urlArquivo, flNome = false) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            downloadResearch(urlArquivo,dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }
                

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getNomeArquivo(urlArquivo) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7)
                    return nmArquivo;
                } else {
                    return "daods";
                }
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createFile(files);
            },

            createFile(files) {
                for (var index = 0; index < files.length; index++) {
                    this.files.push(files[index]);
                }
            },
            removeFile(index) {
                this.files.splice(index, 1)
            },

            getDataBs(item) {
                return ` <span class="mb-0"> ${(item.dsTipoResearch != null ? item.dsTipoResearch : item.dsTipoResearch)}</span>`;
            },

            montaPopover() {
                window.$(".popover").each(function () {
                    window.$(this).remove();
                });
                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popoverModelo"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "top",
                                });
                            });
                    }
                });
            },
        },
        mounted: function () {
            this.load();

            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            reload: function () {
                this.novo();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    textarea {
        border: 1px solid gray;
    }

    .btn-selecionar {
        border-color: #f5f5f5 !important;
    }

    .item-fonte{
        padding: 2px;
        border: 1px solid #ccc;
        border-radius: 5px;
    }

    input[type="file"] {
        display: none;
    }

    .custom-file-upload {
        display: inline-block;
        padding: 6px 25px;
        cursor: pointer;
        background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #FFF;
    }

    .box-files {
        display: flex;

        .item-files{
            display: inline-block;
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 5px;
        }
    }
</style>

